import { useRef } from 'react';

import { useUploadPdf } from '@/components/UploadPDF/hooks';

import { MAX_FILES } from '../UploadPDF/utils';

export function useUploadPdfButton() {
	const inputRef = useRef(null);
	const { getInputProps, loading } = useUploadPdf(inputRef);

	return {
		inputProps: {
			...getInputProps(),
			multiple: MAX_FILES > 1,
			ref: inputRef
		},
		onClick: () => inputRef.current?.click(),
		loading
	};
}
